import { useEffect, useState } from 'react';
import '@vp/pricing-context-module';
import { currentCountry } from 'src/utils/cultureUtil';

const contextChangedEvent = 'PCXT-V3-ContextChanged';

export interface PricingContext {
  market: string;
  couponCode: string;
  vatInclusive: boolean;
}

export interface PricingContextModule {
  init: (tenant: string, market: string) => Promise<PricingContext>;
  getPricingContext(): PricingContext;
}

export function usePricingContext(): PricingContext | null {
  const [pricingContext, setPricingContext] = useState<PricingContext | null>(null);

  useEffect(() => {
    let isStale = false;

    function handleContextChanged() {
      setPricingContext(document.pcxtV3.getPricingContext());
    }

    async function initializePricingContext() {
      if (typeof document === 'undefined') {
        return;
      }

      const pricingContext = await document.pcxtV3.init('vistaprint', currentCountry);
      if (isStale) {
        return;
      }

      setPricingContext(pricingContext);
      document.addEventListener(contextChangedEvent, handleContextChanged, false);
    }
    initializePricingContext();

    return () => {
      isStale = true;
      document.removeEventListener(contextChangedEvent, handleContextChanged);
    };
  }, []);

  return pricingContext;
}
